import type { LalSegmentApi } from '@openx/types/segments.ts';
import { LalSegmentDetailsSection } from './sections/LalSegmentDetailsSection.tsx';
import { LalSegmentOwnerSection } from './sections/LalSegmentOwnerSection.tsx';
import { LalSegmentReachSection } from './sections/LalSegmentReachSection.tsx';
import { LalSegmentSeedsSection } from './sections/LalSegmentSeedsSection.tsx';

export const LalSegmentDetails = ({ lalSegment }: { lalSegment: LalSegmentApi }) => {
  return (
    <>
      <LalSegmentReachSection lalSegment={lalSegment} />
      <LalSegmentDetailsSection lalSegment={lalSegment} />
      <LalSegmentSeedsSection lalSegment={lalSegment} />
      <LalSegmentOwnerSection organizationName={lalSegment.account?.name} providerName={lalSegment.provider?.name} />
    </>
  );
};
